import { defineMessages } from 'react-intl';

export const commonMessage = defineMessages({
    home: 'Home',
    admins: 'Admins',
    adminsLeader: 'Admins Leader',
    news: 'News',
    category: 'Category',
    newsCategory: 'News Category',
    previewFailed: 'Preview failed',
    title: 'Title',
    status: 'Status',
    statusSelect: 'Select status',
    username: 'Username',
    fullName: 'Full name',
    phone: 'Phone',
    group: 'Group',
    createdDate: 'Created date',
    modifiedDate: 'Modified Date',
    userAdmin: 'Admins',
    userAdminLeader: 'Admins Leader',
    profile: 'Profile',
    avatar: 'Avatar',
    currentPassword: 'Current password',
    newPassword: 'New password',
    validatePassword: 'Password must be at least 6 characters',
    confirmPassword: 'Confirm password',
    passwordNotMatch: 'Password not match',
    password: 'Password',
    login: 'Login',
    email: 'Email',
    name: 'Name',
    description: 'Description',
    groupPermission: 'Group Permission',
    listSetting: 'List Setting',
    settingValue: 'Value',
    groupName: 'Group Name',
    isEditable: 'Is Editable',
    isSystem: 'Is System',
    settingKey: 'Setting Key',
    address: 'Address',
    ward: 'Ward',
    district: 'District',
    province: 'Province',
    nation: 'Nation',
    village: 'Village',
    kind: 'Kind',
    user: 'Users',
    birthday: 'Birthday',
    Name: 'Name',
    Kind: 'Kind',
    Province: 'Province',
    District: 'District',
    Village: 'Village',
    Nation: 'Nation',
    showSystemSettings: 'Show system settings',
    hideSystemSettings: 'Hide system settings',
    timeZone: 'Timezone',
    money: 'Money',
    system: 'System',
    administrators: 'Administrators',
    admin: 'Admin',
    restaurantName: 'Restaurant Name',
    restaurantPath: 'Restaurant Path',
    restaurant: 'Restaurant',
    MediaLibrary: 'Media Library',
    Device: 'Device',
    logoPath: 'Logo',
    bannerPath: 'Banner',
    hotline: 'Hotline',
    zipCode: 'ZIP code',
    city: 'City',
    modifiedBy: 'Username',
    shopAccount: 'Shop Account',
    taxNumber: 'Tax Number',
    customer: 'Customers',
    namePrefix: 'Name Prefix',
    confirmNewPassword: 'Confirm New Password',
    postCode: 'Post Code',
    addressNumber: 'Address Number',
    street: 'Street',
    addressNote: 'Address Note',
    userUsername: 'Username',
    // updateStatusSuccess: 'Update status success',
    latitude: 'Latitude',
    longitude: 'Longitude',
    services: 'Services',
    paypalClientId: 'PayPal client ID',
    paypalClientSecrect: 'PayPal client secret',
    paypalCurrentcyCode: 'PayPal currency code',
    language: 'Language',
    restaurantsexpired: 'Restaurant-Expired',
    expired: 'Expired',
    devices: 'Devices',
    updateDatabase: 'Update Database',
    registration: 'registration',
    webPortal: 'Web Portal',
    image: 'Image',
    update: 'Update',
    updateRestaurantSuccess: 'Update restaurant settings successful!',
    restaurantLogo: 'Restaurant Logo',
    restaurantBanner: 'Restaurant Banner',
    cancel: 'Cancel',
    updateRestaurant: 'Update restaurant',
    menu: 'Menu',
    happyHour: 'Happy hour',
    ingredients: 'Ingredients',
    beilageTemplate: 'Beilage template',
    employees: 'Employees',
    generalSettings: 'General settings',
    devicePayment: 'Device Payment',
    pickUpDisplaySettings: 'ReadyBoard settings',
    QRLiveSettings: 'QR Live settings',
    orderSettings: 'Order settings',
    kitplaySettings: 'Kitplay settings',
    editSetting: 'Edit setting',
    printerSettings: 'Printer settings',
    tableSettings: 'Table settings',
    ip: 'IP',
    printer: 'Printer',
    printerManagement: 'Printer management',
    success: 'Success',
    printers: 'Printers',
    print: 'Printer',
    namePrinter: 'Name',
    groupNamePrinter: 'Group',
    isWhite: 'Printer name change to B&W',
    isCheck: 'Check slip',
    isPrintTime: 'Print time',
    isNextCourse: 'Next course',
    isBeep: 'Beep',
    isPrintSeparator: 'Slip count = Food quantity',
    updatePrinterSuccess: 'Update printer settings successful!',
    updateQrCodeLiveSuccess: 'Update QR Live successful!',
    updateOrderSettingSuccess: 'Update Order settings successful!',
    pickUpDisplay: 'ReadyBoard',
    qrCodeLive: 'QR code live',
    frame: 'Frame {no}',
    frameTime: 'Frame',
    dayOfWeek: 'Day of weeks',
    timeOfWeek: 'Time of weeks',
    timeFrame: 'Time frame',
    from: 'From',
    to: 'To',
    mediaKind: 'Media Kind',
    media: 'Media library',
    mediaCount: 'Media {count}',
    mediaOut: 'Media Out',
    mediaCode: 'Media Code',
    timeWork: 'Time Work',
    skipMethod: 'Skip method',
    paymentMethod: 'Payment method',
    mediaDevice: 'Media Device',
    mediaSetting: 'Media setting',
    deviceName: 'Device Name',
    dayOffs: 'Day Offs',
    uploadFileFail: 'Upload file fail',
    uploadFileSuccess: 'Upload file success',
    requireFrom: 'Enter from',
    requireTo: 'Enter to',
    applyAll: 'Apply All',
    applyForAllDevice: 'Apply for all device',
    getFail: 'Get QR Live failed. Please try again!',
    updateSuccess: 'Update QR Live successful!',
    updateFail: 'Update QR Live failed. Please try again!',
    clickUpload: 'Click to Upload',
    restaurantsQrCodeLive: 'Restaurants QR code Live',
    restaurantPickUpDisplay: 'Restaurant ReadyBoard',
    createEmployee: 'New Employee',
    create: 'Create',
    createEmployees: 'Create Employees',
    updateEmployees: 'Update Employees',
    main: 'Order settings',
    message: 'Message',
    distance: 'Distance',
    timeSchedule: 'Time schedule',
    timework: 'Time work',
    requireInputDistanceFirst: 'Please enter km before adding new data',
    regionGoogle: 'Region Google',
    mapKey: 'Map Key',
    km: 'Km',
    minMoney: 'Min money',
    shipMoney: 'Ship money',
    code: 'Code',
    iP: 'IP',
    onlineAppointment: 'Online Appointment (Delivery)',
    onlineAppointmentStep: 'Online Appointment Step (Delivery)',
    restaurantAppointment: 'Restaurant Appointment',
    restaurantAppointmentStep: 'Restaurant Appointment Step',
    expireTime: 'Expire Time',
    scheduleTimeProcessing: 'Schedule Time Processing',
    scheduleTimeArchive: 'Schedule Time Archive',
    timeHideNonePayment: 'Time Hide None Payment',
    timeFinishOneOrder: 'Time finish one order',
    dayOffWeek: 'Day of weeks',
    accepted: 'Accepted',
    processing: 'Processing',
    pickupDone: 'Pickup done',
    deliverDone: 'Delivery done',
    qRLiveDone: 'QR Live done',
    addDistance: 'Add Distance',
    addPrinter: 'Add Printer',
    shopNotFound: 'Shop not found!',
    phoneNumber: 'Phone Number',
    action: 'Action',
    add: 'Create new beilage',
    beilageItems: 'Beilage Items',
    beilageFoodData: 'Food Datas',
    plu: 'PLU',
    price: 'Price',
    addNew: 'New Beilage',
    select: 'Select',
    addBeilageItem: 'Add Beilage Item',
    addBeilageFoodItem: 'Add Food',
    selectBeilageTemplate: 'Select Beilage template',
    selectBeilage: 'Select beilage',
    beilageName: 'Group Name',
    beilageType: 'Select type',
    required: 'Required',
    beilageAlreadyExist: 'Name food condition existed.',
    beilageNotFound: 'Food condition not found.',
    requireName: 'Please enter name',
    save: 'Save',
    productInfo: 'Product Info',
    timeOfWeeks: 'Time of weeks',
    requireTime: 'Require time',
    selectKind: 'Select kind',
    requireImage: 'Please select image',
    requireTimeFrame: 'Please select time frame before adding new data',
    requireValueType: 'Please select value type before adding new data',
    requirePrinter: 'Please select printer before adding new data',
    requireBeilageName: 'Please enter name',
    requirePrinterCode: 'Please select printer code',
    requireUpdateRestaurantFirst: 'Please update restaurant setting before create food!',
    getKeyboardShortcutFail: 'Get keyboard shortcut failed. Please try again!',
    updateSettingsSuccess: 'Update setting successful!',
    updateSettingsfail: 'Update setting failed. Please try again!',
    qrCode: 'QR Code',
    happyHourIn: 'Happy Hours In',
    happyHourOut: 'Happy Hours Out',
    pickup: 'Pickup',
    deliver: 'Delivery',
    addFood: 'Create a new Food',
    updateFood: 'Update Food',
    inPrice: 'In Price',
    outPrice: 'Out Price',
    pickupPrice: 'Pickup Price',
    deliverPrice: 'Delivery Price',
    foodName: 'Food Name',
    type: 'Type',
    systemPosPLU: 'System PLU',
    timeSale: 'Time Sale',
    timeStart: 'Start',
    timeEnd: 'Close',
    inSaleOff: 'In sale off',
    outSaleOff: 'Out sale off',
    saleOff: 'Sale Off',
    foodDataName: 'name',
    foodDataPrice: 'price',
    printerCode: 'Select printer code',
    valueType: 'Value type',
    timeOffs: 'Time Offs',
    newFood: 'New Food',
    addHappyHour: 'Add Happy Hour',
    restaurantRequire: 'Restaurant not found',
    groupFoodRequire: 'Group food not found',
    plRequire: 'PLU cannot be null',
    pluAlreadyExist: 'PLU in exist.',
    foodNotFound: 'Food not found.',
    new: 'New {objectName}',
    foodGroup: 'Food Group',
    food: 'Food',
    groupFoodName: 'Group Food Name',
    beilage: 'Beilage',
    createNewFoodGroup: 'CREATE A NEW FOOD GROUP',
    updateNewFoodGroup: 'UPDATE FOOD GROUP',
    updateIngredients: 'UPDATE INGREDIENT',
    createIngredients: 'CREATE NEW INGREDIENT',
    updateBeilage: 'UPDATE BEIGLAGE',
    createBeilage: 'CREATE NEW BEIGLAGE',
    search: 'Search',
    delete: 'Delete',
    deletePrinterMapping: "Delete printer mapping",
    clear: 'Clear',
    error: 'Error',
    linkPos: 'Link POS',
    successfully: 'successfully',
    failed: 'failed',
    confirm: 'Confirm',
    systemSetting: 'System settings',
    lockSuccess: "The device was locked successfully",
    approveSuccess: "The device was approved successfully",
    lockError: "An error occurred while locking the device",
    approveError: "An error occurred while approving the device",
    timeLoginNull: "No login time available",
    lockKitplayServer: "Lock device",
    approveKitplay: "Activate Kitplay device",
    approveKitplayServer: "Activate device",
    deviceId: "Device ID",
    expireDate: "Expiration date",
    devicePOS: "Kitplay Server",
    kitplayRequest: "Device request",
    managerKitplay: "Kitplay Server Management",
    childDevice: "Kitplay device",
    area: 'Area',
    deviceGroup: "Device group",
    generalSetting: 'General setting',
    mysqlSetting: "MySQL configuration",
    currencyPosition: 'Currency Position',
    prepareTime: 'Prepare time',
    lateTime: 'Late time',
    lockKitplay: "Lock Kitplay device",
    mapping: "Assign printer",
    ok: "Ok",
    edit: "Edit",
    editPrinterMapping: "Edit printer mapping",
    kitPlayShop: 'Shop',
    digibesShop: 'Shop',
    deviceInformation: 'Device Information',
    deviceToken: 'Device token',
    deviceKind: 'Device kind',
    deviceSubKind: 'Device sub kind',
    appConfiguration: 'DPC Config',
    addExtra: 'Add',
    editParams: 'Edit Params',
    tabletRequest: 'Tablet Request',
    approve: 'Approve',
    hasTabletRequest: 'Has tablet request',
    isDigibes: 'Is digibes',
    addDigibes: 'Add digibes restaurant',
    addKitplay: 'Add PI device',
    scanQrCode: 'Scan QR code to setup device',
    wifiInformation: 'Enter Wi-Fi Information',
    continue: 'Continue',
    wifiSSID: 'Wi-Fi SSID',
    wifiPassword: 'Wi-Fi Password',
    appName: 'App name',
    packageName: 'Package',
    launcher: 'Launcher',
    params: 'Params',
    key: 'Key',
    workflow: 'Workflow',
    updateError: 'Update failed. Please try again!',
    unsavedChangesContent: 'You have unsaved changes that will be lost. Continue?',
    unsavedAddGroup: 'You have unsaved changes. Discard and add new group?',
    unsavedEditGroup: 'You have unsaved changes. Discard and edit this group?',
    unsavedDeleteGroup: 'You have unsaved changes. Discard and delete this group?',
    unsavedSwitchTab: 'You have unsaved changes. Discard and switch tab?',
    requireGroupName: 'Please enter group name',
    cyclicDependency: 'Cannot save: there is a circular dependency between groups. Please remove the cycle and try again.',
    invalidConnection: 'Invalid connection between groups. Please remove the red connection and try again.',
    invalidEmail: 'Invalid email format',
    addPiService: 'Add Pi service',
    piService: "Pi Server",
    managerOrderDisplay: "ReadyBoard",
    orderDisplayService: "ReadyBoard Service",
    mappingOrderDisplay: "Assign ReadyBoard",
    digibes: 'Digibes',
    kitplay: 'Kitplay',
    pickupDisplay: 'ReadyBoard',
    deviceRequest: "Device request",
    layout: 'Layout',
    copy: 'Copy',
    copySuccess: 'Copy success!',
    copyFail: 'Copy fail!',
    deleteSuccess: 'Delete {objectName} successfully',
    deleteTitle: 'Are you sure you want to delete this {objectName}?',
    refresh: 'Refresh',
    minute: 'minute',
    showPrice: 'Show price',
    setting: 'Setting',
    timeDeleteArchiveOrder: 'Time delete archive order',
    pushToMpos: 'Push to MPOS',
    pushToMposDelivery: 'Delivery',
    pushToMposImbiss: 'Snack bar',
    pushToMposInhouse: 'Dine-in',
    pushToMposTakeaway: 'Takeaway',
    doneType: 'Done type',
    groupTakeAway: 'Group take away',
    groupDelivery: 'Group delivery',
    kOverlap: 'K-overlap',
    kOverlapTitle0: 'Maximum overlap, longest dish only',
    kOverlapDesc0: 'The kitchen works almost fully in parallel',
    kOverlapTitle1: 'Very high overlap',
    kOverlapDesc1: 'Mostly the longest dish, plus very little time from other dishes',
    kOverlapTitle2: 'High overlap',
    kOverlapDesc2: 'Dishes can be largely prepared interleaved',
    kOverlapTitle3: 'Fairly high overlap',
    kOverlapDesc3: 'The kitchen coordinates well, little extra time added',
    kOverlapTitle4: 'Good parallel kitchen',
    kOverlapDesc4: 'Many dishes are processed at the same time',
    kOverlapTitle5: 'Medium overlap',
    kOverlapDesc5: "Half of the other dishes' time is added",
    kOverlapTitle6: 'Moderate overlap',
    kOverlapDesc6: 'Some parallel work, but not much',
    kOverlapTitle7: 'Low overlap',
    kOverlapDesc7: 'Most dishes must be prepared sequentially',
    kOverlapTitle8: 'Almost cumulative',
    kOverlapDesc8: 'The kitchen rarely works in parallel',
    kOverlapTitle9: 'Nearly cumulative',
    kOverlapDesc9: 'Close to summing up the time of all dishes',
    kOverlapTitle10: 'No overlap, sum total',
    kOverlapDesc10: 'Every dish is counted as if prepared separately',
    upload: 'Upload',
    uploading: 'Uploading',
    tag: 'Tag',
    uploadMediaSuccess: 'Upload media successful',
    uploadMediaFail: 'Upload media fail',
    drivers: 'Drivers',
    state: 'State',
    billing: 'Billing',
    voucherCode: 'Voucher Code',
    voucherType: 'Voucher Type',
    voucherPercent: 'Percentage',
    
    value: 'Value',
    minOrderValue: 'Min Order Value',
    startDate: 'Start Date',
    endDate: 'End Date',
    done: 'Done',
    order: 'Order',
    orderStt: 'Order STT',
    totalMoney: 'Total Money',
    customerName: 'Customer',
    deliveryFee: 'Delivery Fee',
    payment: 'Payment',
    orderType: 'Order Type',
   
    discountAmount: 'Discount Amount',
    redemption: 'Redemption',
    deliveryTrip: 'Delivery Trip',
    deliveryTripDetail: 'Delivery Trip Detail',
    startTime: 'Start time',
    endTimeEstimate: 'End time estimate',
    totalDistance: 'Total distance',
    timeDeliver: 'Time delivery',
    viewMap: 'View map',
    foodBreakCount: 'Food break count',
    viewDeliveryTrip: 'View delivery trip',
    ordercon: 'Ordercon',
    qrLive: 'QR Live',
    thirdParty: 'Third party',
    piServer: 'Pi Server',
    deleteDeviceConfirm: 'Are you sure you want to delete this device?',
    deleteDeviceSuccess: 'Delete device successfully',
    deletePrinterConfirm: 'Are you sure you want to delete this printer?',
    yes: 'Yes',
    no: 'No',
    management: 'Management',
    // === New messages for placeholders and labels ===
    placeholderUsername: 'Please enter username',
    placeholderFullName: 'Please enter full name',
    placeholderPassword: 'Please enter password',
    placeholderConfirmPassword: 'Please enter Confirm password',
    placeholderPhone: 'Please enter phone',
    placeholderZipCode: 'Please enter zip code',
    placeholderCity: 'Please enter city',
    placeholderAddress: 'Please enter address',
    placeholderTaxNumber: 'Please enter tax number',
    placeholderDeviceName: 'Device name',
    placeholderDeviceId: 'Device ID',
    placeholderIpSocket: 'IP update when active device',
    placeholderGroupName: 'Group name',
    placeholderQuestion: 'Question',
    placeholderFooterMessage: 'Footer Message',
    placeholderTimeWaitNotify: 'Time wait for notify support',
    placeholderWifiSsid: 'Enter Wi-Fi SSID',
    placeholderWifiPassword: 'Enter Wi-Fi Password',
    placeholderKey: 'Key',
    option: 'Option',
    options: 'Options',
    addOption: 'Add Option',
    settings: 'Settings',
    url: 'url',
    dpcApp: 'DPC APP',
    componentName: 'Component name',
    signature: 'Signature',
    provisioningSkipEncryption: 'Provisioning skip encryption',
    provisioningLeaveAllSystemEnabled: 'Provisioning leave all system enabled',
    uploadFileSuccessMessage: 'Upload file success',
    uploadFailedMessage: 'Upload failed',
    addFileSuccess: 'Add file success',
    addFileFailed: 'Add file failed',
    updateAppConfigSuccess: 'Update app configuration success',
    updateAppConfigFailed: 'Update app configuration failed',
    createAppConfigSuccess: 'Create app configuration success',
    createAppConfigFailed: 'Create app configuration failed',
    keyIsRequired: 'Key is required',
    duplicateKey: 'Duplicate key',
    permission1: 'Restaurant management',
    permission2: 'Delete ordered food and print to kitchen',
    permission3: 'Delete incorrectly ordered food',
    permission4: 'View sales report',
    pleaseSelectPermission: 'Please select at least one permission',
    invalidOrder: 'Invalid order.',
    readyBoardMappingNumber: 'ReadyBoard mapping number',
    readyBoardMapping: 'ReadyBoard mapping',
    notificationSuccess: 'Success',
    notificationError: 'Error',
    notificationWarning: 'Warning',
    randomColor: 'Random Color',
    showPLU: 'Show PLU',
    sortPLU: 'Sort PLU',
    displayFoodByCustomer: 'Display food by customer',
    printerNumber: 'Printer number',
    printerType: 'Type',
    getListError: 'Get list error',
    deleteFailed: 'Delete {objectName} failed',
    updateStatusSuccess: 'Update status success',
    lockStatusSuccess: 'Lock status success',
    lockConfirm: 'Are you sure to lock this {objectName}?',
    activeConfirm: 'Are you sure to active this {objectName}?',
    id: 'ID',
    appManagement: 'App Management',
    appVersion: 'App Version',
    uploadNewVersion: 'Upload New Version',
    minVersion: 'Min Version',
    thisVersion: 'This Version',
    version: 'Version',
    requiredUpdate: 'Required Update',
    fileUpload: 'File Upload',
    fileName: 'File Name',
    dateRelease: 'Release Date',
    minVersionLessThan: 'Min version must be less than this version',
    uploadVersionSuccess: 'Upload version successfully',
    uploadVersionFailed: 'Upload version failed',
    thisVersionGreaterThan: 'This version must be greater than current version',
    selectFileFirst: 'Please select a file first',
    versionDPC: 'DPC',
    versionORDERCON: 'ORDERCON',
    versionKITPLAY: 'KITPLAY',
    versionPISERVER: 'PI SERVER',
    noData: 'No data',
    activeVersion: 'Active Version',
    clickOrDragToReplace: 'Click or drag another file to replace',
    dragOrClickToSelectFile: 'Drag and drop or click to select file',
    all: 'All',
    supportedFormat: 'Supported format:',
    createNewVersion: 'Create New Version',
    voucher: 'Voucher',
    voucherValue: 'Value',
    totalUsed: 'Total Used',
    createVoucher: 'Create Voucher',
    updateVoucher: 'Update Voucher',
    doneVoucher: 'Done',
    doneVoucherConfirm: 'Are you sure you want to mark this voucher as done?',
    scheduled: 'Scheduled',
    voucherRedemption: 'Voucher Redemption',
    randomCode: 'Random Code',
    valueMustNotExceed100: 'Value must not exceed 100 for percent type',
    startDateMustBeFuture: 'Start date must be in the future',
    endDateMustBeAfterStart: 'End date must be after start date',
    valueMustBeGreaterThanZero: 'Value must be greater than 0',
    onlineAppointmentPickUp: 'Online Appointment (Pick Up)',
    onlineAppointmentStepPickUp: 'Online Appointment Step (Pick Up)',
    serverProvider: 'Server Provider',
    serverInfo: 'Server Info',
    mysqlInfo: 'Mysql Info',
    mysqlHost: 'MySql Host',
    port: 'Port',
    jdbcUrl: 'JDBC URL',
    driverClassName: 'Driver ClassName',
    rootUser: 'MySql Root User',
    rootPassword: 'MySql Root Password',
    serverId: 'Server Id',
    maxTenant: 'Max Tenant',
    apiUrl: 'Api Url',
    max: 'Max',
    count: 'Count',
});
